import { ReactElement } from 'react';
import { Props } from './FilteringPanel.types';
import './FilteringPanel.scss';

export const FilteringPanel = ({ availableElements, selectedElement, onClick }: Props): ReactElement => (
  <div className={'Manufacturers-FilteringPanel'}>
    {Array.isArray(availableElements)
      && availableElements.map((element) => {
        if (element === selectedElement) {
          return (
            <span
              className={
                'Manufacturers-FilteringPanelElement Manufacturers-FilteringPanelElement--Selected'
              }
              key={element}
            >
              {element}
            </span>
          );
        }

        return (
          <span
            className={'Manufacturers-FilteringPanelElement cds-Link'}
            key={element}
            onClick={onClick(element)}
          >
            {element}
          </span>
        );
      })}
  </div>
);
